
import { AuthTypes } from '@services/data-types/user';
import { refreshTokenService } from '@services/user';
import { useCompanyStore } from '@store/company';
import { useAuthStore } from '@store/user';
import { useMutation } from '@tanstack/react-query';
import { setCredentialRequest } from '@utils/axioswithintercept';
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { shallow } from 'zustand/shallow';
import { PublicStack } from './routes';

interface ProtectedRouteProps {
  children: JSX.Element,
  redirectPath?: string
}
const ProtectedRoute = ({ redirectPath = PublicStack.login.path, children, }: ProtectedRouteProps) => {
  const {
    token, expires_in, refresh_token, updateAuth, logout, email
  } = useAuthStore((state) => ({
    token: state.auth.token,
    expires_in: state.auth.expires_in,
    refresh_token: state.auth.refresh_token,
    email: state.profile.email,
    updateAuth: state.updateAuth,
    logout: state.logout
  }), shallow)
  const { company_id } = useCompanyStore((state) => ({ company_id: state.splash.id }), shallow)
  const params = useParams()
  const [loading, setLoading] = useState<boolean>(true)
  const navigate = useNavigate()

  const refTimeOut = useRef<null | ReturnType<typeof setTimeout>>(null)

  const reloginMutate = useMutation({
    mutationFn: () => {
      return refreshTokenService({ email: email, company_id: company_id, refresh_token: refresh_token })
    },
    onSuccess({ data }, variables, context) {
      var responsedata: AuthTypes = data
      var expires = new Date();
      var now = new Date().getTime()
      expires.setMinutes(expires.getMinutes() + parseInt(responsedata.expires_in.toString()));
      responsedata.expires_in = expires.getTime();
      setLoading(false)
      setCredentialRequest({ token: responsedata.token })
      updateAuth(responsedata)

      const dateRange = expires.getTime() - now
      refTimeOut.current = setTimeout(() => {
        reloginMutate.mutate()
      }, dateRange);

    }, onError(error, variables, context) {
      logout()
      navigate(PublicStack.login.path.replace(":schedule", params.schedule!), { replace: true })
    },
  })

  const checkAuth = useCallback(async () => {
    const now = new Date().getTime()
    const exp = new Date(expires_in).getTime()

    if (now > exp) {
      reloginMutate.mutate()
    } else {
      const dateRange = exp - now
      refTimeOut.current = setTimeout(() => {
        reloginMutate.mutate()
      }, dateRange);

      setLoading(false)
      setCredentialRequest({ token })
    }
  }, [refresh_token, token])

  useLayoutEffect(() => {
    checkAuth()
    return () => clearTimeout(refTimeOut.current!)
  }, [])

  useEffect(() => {
    if (token === '') {
      setCredentialRequest({ token: null })
    }
  }, [token])

  if (token === '') return <Navigate to={`${redirectPath.replace(':schedule', params.schedule!)}`} replace />;
  if (loading) return <div>Cek Autentikasi...</div>
  return children
};
export default ProtectedRoute